import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";
import TeacherRouter from "./TeacherRouter";
import StudentRouter from "./StudentRouter";
import AdminRouter from "./AdminRouter";
import TeacherApprovalStatus from "../pages/teacherPages/TeacherApprovalStatus";

const PrivateRouter = () => {
  const { role } = useSelector((state) => state.login);
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: "antiquewhite",
          width: "100vw",
          height: "100vh",
        }}
      />
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!role) {
    return <div>Resolving user role...</div>;
  }

  if (role === "admin") return <AdminRouter />;
  if (role === "pending_teacher" || role === "rejected_teacher") {
    return <TeacherApprovalStatus />;
  }
  if (role === "teacher") return <TeacherRouter />;
  return <StudentRouter />;
};

export default PrivateRouter;
